import dayjs from 'dayjs';
import { forgotPassword, resetPassword, expiredPassword } from '../../utils/api';
import { getUserResetPassword, getUsersResetPassword, setUserResetPassword, setUsersResetPassword } from '../../utils/storage';
import { CHANGED, FAILED, LOADING, MESSAGE, REMINDER_DURATION, SUCCESS_MESSAGE, FETCHED } from './constants';

export function resetPasswordUser(data) {
  const users = getUsersResetPassword();
  const user = getUserResetPassword();
  return async (dispatch) => {
    dispatch(loadingAction(true));

    try {
      const res = await resetPassword(data);
      dispatch(loadingAction(false));
      dispatch(
        messageAction(
          res.code === 200
            ? 'Berhasil memperbarui kata sandi, silakan masuk dengan kata sandi baru.'
            : res.message,
          res.code
        )
      );
      setUsersResetPassword(users.filter((item) => item.email !== user.email));
      setTimeout(() => {
        location.href = '/dc/login';
      }, 2000);
    } catch ({ message, code }) {
      dispatch(loadingAction(false));
      dispatch(failedAction(message, code));
    }
  };
}

export function requestForgotPassword(username) {
  const isAvailable = (time) => {
    const diff = dayjs().diff(dayjs(time), 'second');
    const timeLeft = REMINDER_DURATION - diff;
    return timeLeft <= 0;
  };

  const users = getUsersResetPassword();
  const user = users.find(({ email }) => email === username);
  setUserResetPassword({ email: username });

  return async (dispatch) => {
    dispatch(loadingAction(true));

    try {
      const res = await forgotPassword(username);
      dispatch(loadingAction(false));
      dispatch(messageAction(res.message,res.code));
      if (!isAvailable(user?.time)) {
        users.push({ email: username, time: new Date(), duration: res.data.duration });
        setUsersResetPassword(users);
      } else {
        setUsersResetPassword(
          users.map((item) => ({
            ...item,
            duration: res.data.duration,
            time: item.email === user?.email && new Date(),
          }))
        );
      }
    } catch ({ message, code }) {
      dispatch(loadingAction(false));
      dispatch(failedAction(message, code));
    }
  };
}

export function fetchPasswordExpired(username) {
  return async (dispatch) => {
    dispatch(loadingAction(true));
    const key = 'expired';

    try {
      const res = await expiredPassword(username);
      dispatch(loadingAction(false));
      dispatch(fetchedAction({ code: res.code, message: res.message, data: res.data, key }));
    } catch ({ code, message, data }) {
      dispatch(loadingAction(false));
      dispatch(fetchedAction({ code, message, data, key }));
    }
  };
}

export function clearError() {
  return async (dispatch) => {
    dispatch(messageAction(''));
    dispatch(failedAction(''));
  };
}

export const fetchedAction = (payload) => ({
  type: FETCHED,
  ...payload,
});

export const loadingAction = (isLoading = true) => ({
  type: LOADING,
  isLoading,
});

export function failedAction(message, code = 500) {
  return { type: FAILED, message, code };
}

export function messageAction(message, code = 200, duration) {
  return { type: MESSAGE, message, code, duration };
}

export const passwordChangedAction = (
  success = true,
  message = SUCCESS_MESSAGE
) => ({
  type: CHANGED,
  success,
  message,
});
